<template>
  <content-editor
    permission="page"
    :fields="fields"
    @update="updateState"
    :publication="true"
    :hasAuthor="false"
    previewModule="page"
    endpoint="page"
    module="page"
  >
  </content-editor>
</template>

<script>
import ContentEditor from '@/components/editor/content_blocks/ContentEditor.vue';
import ContentDetail from '@/mixins/contentEditor/Detail';

export default {
  mixins: [ContentDetail],
  components: {
    ContentEditor,
  },
  data() {
    return {
      module: 'page',
      fields: [
        {
          name: 'notes',
          required: false,
        },
        {
          name: 'name',
          required: true,
        },
        {
          name: 'lightbox',
          required: false,
        },
        {
          name: 'read-confirmation',
          required: false,
        },
        {
          name: 'url',
          required: true,
        },
        {
          name: 'targets',
          required: false,
        },
        {
          name: 'status',
          required: true,
        },
        {
          name: 'parentPage',
          required: false,
        },
        {
          name: 'internal',
          required: true,
        },
        {
          name: 'auth_contact_people',
          required: true,
        },
        {
          name: 'seo_keywords',
          required: false,
        },
      ],
    };
  },
};
</script>
